<template>
    <div class="praise">
        <div class=" text-box type1">
            <ul class="text-box__list">
                <li class="text-box__item">
                    <p>의료진, 간호사, 병동 직원 분들에게 따뜻한 말한마디 전해주세요.</p>
                </li>
                <li class="text-box__item">
                    <p>근거없는 비방 및 욕설 광고성 글은 관리자의 판단에 따라 무통보 삭제될 수 있습니다.</p>
                </li>
                <li class="text-box__item">
                    <p>등록된 글은 <b>마이페이지 > 나의 작성글 > 칭찬합니다</b> 에서 확인이 가능하며 승인 된 글은 수정이 불가합니다.</p>
                </li>
                <li class="text-box__item">
                    <p>승인된 글은 타인이 열람 가능하므로 작성 시 개인정보는 노출되지 않게 유의해주시기 바랍니다.</p>
                </li>
                <li class="text-box__item">
                    <p>개인정보수정을 원할 경우 <b>마이페이지 > 회원정보 > 회원정보수정</b> 메뉴를 이용해주시기 바랍니다.</p>
                </li>
            </ul>
        </div>
        <div class="contents text-box type2">
            <h3 class="text-box__tit">개인정보 수집 및 이용목적에 대한 동의 <span class="c-red">(필수)</span></h3>
            <div class="text-box__wrap">
                <p>
                    자료 수급예정
                </p>
            </div>
        </div>
        <div class="agree-input">
            <label for="agree-y" class="agree-input__item">
                <input type="radio" id="agree-y" class="agree-input__radio" name="agree">
                <span class="icon"></span>
                동의합니다
            </label>
            <label for="agree-n" class="agree-input__item">
                <input type="radio" id="agree-n" class="agree-input__radio" name="agree">
                <span class="icon"></span>
                동의하지 않습니다
            </label>
        </div>

        <div class="contents input-form type1">
            <p class="input-form__top-text"><span class="c-red">* </span> 필수 입력항목</p>
            <ul class="input-form__list">
                <li class="input-form__item">
                    <div class="input-form__box">
                        <div class="tit">이름</div>
                        <div class="cont">이준용</div>
                    </div>
                </li>
                <li class="input-form__item item2">
                    <div class="input-form__box">
                        <div class="tit">휴대전화</div>
                        <div class="cont">010-1234-5678</div>
                    </div>
                    <div class="input-form__box">
                        <div class="tit">이메일</div>
                        <div class="cont">hahaha0800</div>
                    </div>
                </li>
                <li class="input-form__item">
                    <div class="input-form__box">
                        <div class="tit"><span class="c-red">* </span>환자와의 관계</div>
                        <div class="cont radio">
                            <div class="input-form__radio">
                                <label class="input-item">
                                    <input type="radio" class="radio" name="radio1" @change="isChecked = false">
                                    <span class="icon"></span>
                                    본인
                                </label>
                                <label class="input-item">
                                    <input type="radio" class="radio" name="radio1" @change="isCheckedFn">
                                    <span class="icon"></span>
                                    보호자
                                </label>
                            </div>
                            <label class="cont__text">
                                <input type="text" class="cont__text-input" :disabled="!isChecked">
                                <p class="present">보호자 선택 시 환자명을 입력해 주세요.</p>
                            </label>
                        </div>
                    </div>
                </li>
                <li class="input-form__item item2">
                    <div class="input-form__box">
                        <div class="tit"><span class="c-red">* </span>칭찬 직원(의료진)</div>
                        <div class="cont"><input type="text" class="cont__text-input"></div>
                    </div>
                    <div class="input-form__box">
                        <div class="tit">부서/병동</div>
                        <div class="cont"><input type="text" class="cont__text-input"></div>
                    </div>
                </li>
                <li class="input-form__item desc">
                    <div class="input-form__box">
                        <div class="tit"><span class="c-red">* </span>칭찬 직원(의료진)</div>
                        <div class="cont"><textarea name="" id=""></textarea></div>
                    </div>
                </li>
            </ul>
            <div class="contents btn-wrap center">
                <a href="javascript:;" class="btn">취소</a>
                <a href="javascript:;" class="btn blue">등록</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isChecked: false
            };
        },
        methods: {
            isCheckedFn() {
                this.isChecked = true;
            }
        }
    };
</script>